import { connect } from 'react-redux';

import {
  getDashboardEventsGroupColumn,
  getDashboardEvenIds,
  getDashboardEventName,
  getMetainf,
} from '../../../../../reducers/analyticsApp';
import { usageEvents } from '../../../../../constants/event';
import { prepareDropdown } from '../../../../../utils/common';
import EventsFieldOption from '../../../../../components/event/FieldOption';
import { groupByExcludeFields } from '../../../../../constants/metainf';
import { setGroupColumn } from '../../../../../actions/dashboards/events';

const mapStateToProps = (state, { unitId, id: eventId }) => {
  const eventIds = getDashboardEvenIds(state, unitId);

  const usageEventIds = eventIds.filter((id) => {
    const name = getDashboardEventName(state, unitId, id);
    return !!usageEvents[name];
  });

  const visible = !usageEventIds.includes(eventId);

  if (!visible) {
    return {
      visible,
    };
  }

  // In case some of events is usage event
  // we are not able to change group column
  // It equals to the default one for that
  // usage event
  const disabled = usageEventIds.length > 0;

  const uniqEventNames = Array.from(
    new Set(eventIds.map((id) => getDashboardEventName(state, unitId, id)).filter((name) => !!name))
  );

  // In case we have more than one uniq event name
  // we must display only common fields (attributes)
  const eventName =
    disabled || uniqEventNames.length > 1
      ? undefined
      : getDashboardEventName(state, unitId, eventId);

  const metainf = getMetainf(state, eventName);
  const fields = prepareDropdown(metainf, false, groupByExcludeFields);

  return {
    label: 'Group by:',
    value: getDashboardEventsGroupColumn(state, unitId),
    values: fields,
    disabled,
    visible: true,
    allowClear: false,
  };
};

const mapDispatchToProps = (dispatch, { unitId }) => ({
  onChange: (value) => dispatch(setGroupColumn(unitId, value)),
});

const EventsGroupByFieldOption = connect(mapStateToProps, mapDispatchToProps)(EventsFieldOption);

export default EventsGroupByFieldOption;
